import React,{ FC} from 'react';
import { PreferenceCardContainer } from '../Pages/InstallationPreferencePage/PreferenceCardContainer';
import {ImportConfigurationContainer} from "../Pages/ImportConfigurationPage/ImportConfigurationContainer";
import {DeviceRegistrationContainer} from "../Pages/DeviceRegistrationPage/DeviceRegistrationContainer";
import DownloadPage from "../Pages/DownloadPage/DownloadPage";
import { Page } from '../../CommonUtils/Enums';
import {useRecoilValue} from "recoil";
import { pageNameAtom } from '../../Recoil State/Atoms/PageAtoms';

const CustomRouterComp : FC= () => {

  const pageNameState=useRecoilValue(pageNameAtom);

  return (
    <>
    {(pageNameState === Page.DeviceRegistration) && <DeviceRegistrationContainer heading="IG App Installer Provisioning" isKeyboardRequiredOnInit={true}/>}
    {(pageNameState === Page.InstallationPreferences) && <PreferenceCardContainer heading="Installation Preferences" isKeyboardRequiredOnInit={false}/>}
    {(pageNameState === Page.ImportConfiguration) && <ImportConfigurationContainer heading="Import Configuration" isKeyboardRequiredOnInit={false}/>}
    {(pageNameState === Page.DownloadPage) && <DownloadPage />}            
    </>
  )
}


export default React.memo(CustomRouterComp);